module.exports = __webpack_public_path__ + "static/media/sportAvatar__nba2k.816e151f.jpg";